<template>
	<div class="full">
		<vxe-grid :loading="loading" ref="initinputinvoiceorderTable" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			data: {
				default: () => {
					return null
				}
			},
			store: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				list_autorender:false,
				loading:false,
				step: 1,
				invoicedata:[],
				tab:[],
				goodsUids:[],
				currentrow:null,
				modal_model: true,
				modal_title: '生成亿企赢单据',
				modal_width: 1200,
				modal_height: 800,
				list_footerField:[
					{field:'size',toFixed:4},
					{field:'stockamount',toFixed:4},
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			sourcefile(row) {
				this.invoicedata = {
					invoiceNumber:row.invoiceNumber,
					customerId:row.customerId,
					invoiceId:row.invoiceId,
					orderId:row.orderId,
					orderPlant:row.orderPlant,
					invoiceType:1
				}
				this.tab = ['invoice','detail']
				this.$nextTick(()=>{
					this.$refs.invoiceConfig.modal_show()
				})
			},
			invoiceConfigHide(){
				this.customreload()
			},
			createorder(){				
				this.$confirm('是否生成采购单？').then(()=>{
					let detail = this.$refs.initinputinvoiceorderTable.getTableData().visibleData
					this.loading = true
					this.$api.invoice.createorderyqdzpurchaseorder({
						invoiceNumber:this.store.invoicelist[0].invoiceNumber,
						detail:detail,
					}).then(()=>{
						this.loading = false
						this.$message.success('操作成功')
					},()=>{
						this.loading = false
					})
				})
			},
			// createorder(row){
			// 	this.$confirm('是否确认生成？').then(()=>{
			// 		this.loading = true
			// 		this.$api.invoice.createorderyqdzorder({
			// 			data:row,
			// 			totaldata:this.$refs.initoutputinvoiceorderTable.getTableData().fullData,
			// 			date:new Date(this.date).getTime()/1000
			// 		}).then(()=>{
			// 			this.loading = false
			// 			this.customreload()
			// 			this.$message.success('操作成功')
			// 		},()=>{
			// 			this.loading = false
			// 		})
			// 	})
			// },
			deleteorder(row){
				this.$confirm('是否确认删除？').then(()=>{
					this.loading = true
					this.$api.invoice.deleteorderyqdzorder({
						data:row,
					}).then(()=>{
						this.loading = false
						this.customreload()
						this.$message.success('操作成功')
					},()=>{
						this.loading = false
					})
				})
			},
			list_beforeCreateGrid(gridOptions){
				gridOptions.toolbarConfig.buttons = [{
					name: '生成采购单',
					status: 'primary',
					code: 'createorder'
				}]
				gridOptions.columns = [{
						type: 'seq',
						title: '#',
						width:50
					},
					{
						field: 'goodsName',
						title: '商品名称',
						sortable:true,
					},
					{
						field: 'cargoName',
						title: '存货名称',
					},
					{
						field: 'spec',
						title: '规格型号',
					},
					{
						field: 'unit',
						title: '单位',
					},												
					{
						field: 'unitPrice',
						title: '单价',
					},
					{
						field: 'size',
						title: '数量',
					},
					{
						field: 'stockamount',
						title: '入库金额',
					},
				]
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					let data = []
					let commondata = this.commonInbound()
					data = data.concat(commondata)
					this.offsetInbound().then((offsetInbound)=>{
						//console.log(offsetInbound,444)
						data = data.concat(offsetInbound)
						console.log(data)
						resolve({
							list:data
						})
					})
				})
			},
			commonInbound(){
				//console.log(this.store,77)
				let data = JSON.parse(JSON.stringify(this.store.initinputinvoiceorder))
				
				data = data.filter((item)=>{
					return item.inboundtype == 1
				})
				//console.log(data,7878)
				let group = this.$Lodash.groupBy(data,'spec')
				for(let i in group){
					let stockamount = this.$Lodash.sumBy(group[i],(item)=>{
						return parseFloat(item.stockamount)
					})
					let size = this.$Lodash.sumBy(group[i],(item)=>{
						return parseFloat(item.size)
					})
					group[i] = group[i][0]
					group[i].stockamount = stockamount.toFixed(4)
					group[i].size = size
					if(group[i].size){
						group[i].unitPrice = (stockamount/size).toFixed(4)
					}else{
						group[i].unitPrice = 0
					}					
				}
				
				return this.$Lodash.values(group)
			},
			offsetInbound(){
				return new Promise((reslove)=>{
					let newitems = []
					let data = JSON.parse(JSON.stringify(this.store.initinputinvoiceorder))
					data = data.filter((item)=>{
						return item.inboundtype == 2
					})
					let datagroup = this.$Lodash.groupBy(data,'cargoName')
					for(let i in datagroup){
						let obj = datagroup[i][0]
						obj.stockamount = this.$Lodash.sumBy(datagroup[i],(item)=>{
							return parseFloat(item.stockamount)
						})
						datagroup[i] = obj
					}
					data = this.$Lodash.values(datagroup)
					//console.log(data,111)
					if(data.length){
						this.loading = true
						this.$api.invoice.getinventoryreport({
							invoiceNumber:this.store.invoicelist[0].invoiceNumber
						}).then((res)=>{
							data.forEach((item)=>{
								let newitem = this.getoffsetInbounditem(res,item.cargoName,item.stockamount)	
								if(newitem.length){
									newitems = newitems.concat(newitem)
								}else{
									newitems = newitems.concat(item)
								}
								
							})
							reslove(newitems)
							this.loading = false
						},()=>{
							this.loading = false
						})
					}else{
						reslove(newitems)
					}
					
				})

				//console.log(data)
			},
			getoffsetInbounditem(res,categoryName,stockamount){
				let target = res.filter((item)=>{
					//console.log(('*' + item.categoryName + '*' + item.inventoryName),categoryName)
					return ('*' + item.categoryName + '*' + item.inventoryName) == categoryName && item.endAmount < 0 && item.endUnitPrice!=0
				})
				if(!target.length){
					target = res.filter((item)=>{
						//console.log(('*' + item.categoryName + '*' + item.inventoryName),categoryName)
						return ('*' + item.categoryName + '*' + item.inventoryName) == categoryName
					})
				}
				let totalendAmount = this.$Lodash.sumBy(target,(item)=>{
					return parseFloat(item.endAmount)
				})
				
				let data = []
				target.forEach((item)=>{
					let itemstockamount = item.endAmount/totalendAmount * stockamount
					let itemsize = itemstockamount/item.endUnitPrice
					data.push({
						id:item.inventoryId,
						cargoName:categoryName,
						spec:item.specification,
						unit:item.unit,
						unitPrice:item.endUnitPrice,
						size:itemsize.toFixed(4),
						stockamount:itemstockamount.toFixed(4)
					})
				})
				//console.log(data,888)
				return data
				
				
			},
			valid(){
				let data = this.$refs.initoutputinvoiceorderTable.getTableData().fullData
				let cargoNameBuff = false
				for(let i =0 ;i<data.length;i++){
					if(!data[i].cargoName){
						cargoNameBuff = data[i]
						break;
					}
				}
				if(cargoNameBuff){
					this.$refs.initoutputinvoiceorderTable.scrollToRow(cargoNameBuff)
				}
				return cargoNameBuff
			},
			submit() {

				//this.init()
			},
			reset() {
				//this.init()
			},
			customreload() {
				this.$refs.initinputinvoiceorderTable.commitProxy('query')
			},
		},
		components: {

		}
	}
</script>